import React from "react";
import IconChamber from "../../Icons/Module/Chamber";
import IconImager from "../../Icons/Module/Imager";
import IconLoadport from "../../Icons/Module/LoadPort";
import IconPsr from "../../Icons/Module/Psr";
import IconRip from "../../Icons/Module/Rip";
import IconSuite from "../../Icons/Module/Suite";
import { EModuleType } from "../../Model/EModuleType";
import "./OverviewStatus.css";
import IconTemperature from "../../Icons/SideMenu/Temperature";

export enum EOverviewModuleStatus {
  Idle,
  Busy,
  Error,
}

type Props = {
  style?: React.CSSProperties;
  name: string;
  moduleType: EModuleType;
  statusses: { [index: string]: React.ReactNode };
  moduleStatus: EOverviewModuleStatus;
  children?: React.ReactNode;
  icon?: React.ReactNode;
};

export default function OverviewStatus({
  style,
  name,
  moduleType,
  statusses,
  moduleStatus,
  children,
  icon,
}: Props) {
  let headIcon = icon;
  switch (moduleType) {
    case EModuleType.CHAMBER: {
      headIcon = <IconChamber />;
      style = {
        ...style,
        order: 7,
      };
      break;
    }

    case EModuleType.CHILLER: {
      // atau EModuleType.PELTIER
      headIcon = <IconTemperature color="white" />;
      style = {
        ...style,
        order: 6,
      };
      break;
    }

    case EModuleType.IMAGER: {
      headIcon = <IconImager />;
      style = {
        ...style,
        order: 2,
      };
      break;
    }

    case EModuleType.LOADPORT: {
      headIcon = <IconLoadport />;
      style = {
        ...style,
        order: 5,
      };
      break;
    }

    case EModuleType.PSR: {
      headIcon = <IconPsr />;
      style = {
        ...style,
        order: 3,
      };
      break;
    }

    case EModuleType.RIP: {
      headIcon = <IconRip />;
      style = {
        ...style,
        order: 4,
      };
      break;
    }

    case EModuleType.SUITE: {
      headIcon = <IconSuite />;
      style = {
        ...style,
        order: 1,
      };
      break;
    }
  }

  const contents = Object.entries(statusses).map(([key, value], idx) => (
    <div className="overview-statue-header-content" key={key}>
      {!key.startsWith("hide") && (
        <span className="overview-statue-header-content-key">{key}: </span>
      )}
      <span className="overview-statue-header-content-value">{value}</span>
    </div>
  ));

  const color =
    moduleStatus === EOverviewModuleStatus.Error
      ? "red"
      : moduleStatus === EOverviewModuleStatus.Busy
      ? "yellow"
      : "green";

  return (
    <div className="overview-status" style={style}>
      <div className="overview-status-header">
        <div className="overview-status-header-icon">{headIcon}</div>
        <div className="overview-status-header-name">{name}</div>
        <div className="overview-status-header-status">
          <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="6" cy="6" r="6" fill={color} />
          </svg>
        </div>
      </div>
      <div className="overview-status-body">
        {contents}
        {children}
      </div>
    </div>
  );
}
